import { Component } from '@angular/core';
import { FooterComponent } from '../../../../landing-page-v2/components/footer/footer.component';
import { HeaderComponent } from '../../../../landing-page-v2/components/header/header.component';
import { FixedCallComponent } from '../../fixed-call/fixed-call.component';

@Component({
  selector: 'app-real-estate-industry',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, FixedCallComponent],
  templateUrl: './real-estate-industry.component.html',
  styleUrl: './real-estate-industry.component.scss',
})
export class RealEstateIndustryComponent {
  constructor() {}
}
